import { CheckCircle2, AlertTriangle, XCircle, ShieldCheck } from "lucide-react";

const STYLES = {
  ok: "border-emerald-100 bg-emerald-50/50",
  warn: "border-amber-200 bg-amber-50/60",
  fail: "border-rose-200 bg-rose-50/60",
};

function Icon({ status }) {
  if (status === "ok") return <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" />;
  if (status === "warn") return <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" />;
  return <XCircle className="h-4 w-4 text-rose-600 shrink-0 mt-0.5" />;
}

/**
 * PreflightChecklist — FinanzOnline/Elster-Vorabprüfung bereits in der Vorschau
 * (zusammen mit den Plausi-Hinweisen), nicht erst beim Download.
 */
export function PreflightChecklist({ preflight, testId = "preflight-checklist" }) {
  if (!preflight || !preflight.checks?.length) return null;
  const fails = preflight.checks.filter((c) => c.status === "fail").length;
  return (
    <div className="border border-zinc-200 rounded-lg p-3 bg-white" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className="h-4 w-4 text-slate-500" />
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">
          FinanzOnline / Elster Vorab-Check
        </span>
        {preflight.can_download ? (
          <span className="text-[11px] font-medium text-emerald-700 ml-auto" data-testid="preflight-ready">
            einreichbereit
          </span>
        ) : (
          <span className="text-[11px] font-medium text-rose-700 ml-auto" data-testid="preflight-blocked">
            {fails} Blocker — vor Einreichung beheben
          </span>
        )}
      </div>
      <div className="space-y-1.5">
        {preflight.checks.map((c, i) => (
          <div key={i}
            className={`flex items-start gap-2.5 rounded-lg border px-3 py-2 ${STYLES[c.status] || STYLES.warn}`}
            data-testid={`preflight-check-${c.id}-${i}`}>
            <Icon status={c.status} />
            <div className="text-xs">
              <div className="font-medium text-slate-800">{c.label}</div>
              {c.detail && <div className="text-slate-500 mt-0.5">{c.detail}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
